import { BaseService } from './baseService';
import { RehabProtocolDto, RehabProtocolFormData } from '../types/rehabProtocol'; 

class RehabProtocolService extends BaseService<RehabProtocolDto, RehabProtocolFormData> {
    constructor() {
        super('/RehabProtocol');
    }
}

export const rehabProtocolService = new RehabProtocolService();